import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './radix-stream.css'

const RadixStream = (props) => {
  return (
    <div className="radix-stream-container10">
      <Helmet>
        <title>Radix Stream Wallet Case Study | Vlad Butucariu</title>
        <meta
          name="description"
          content="Mobile product design, UX/UI, and identity for Radix Stream, a wallet designed around clear onboarding, tracking, and transactions."
        />
        <meta
          property="og:title"
          content="Radix Stream Wallet Case Study | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="Designing a clearer mobile wallet experience for passive tracking and active use."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/radix-stream" />
        <meta
          property="og:url"
          content="https://vladbutucariu.com/radix-stream"
        />
      </Helmet>
      <div className="radix-stream-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="radix-stream-thq-top-section-elm">
          <div className="radix-stream-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="radix-stream-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="radix-stream-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="radix-stream-thq-section-elm1">
            <div className="radix-stream-thq-color-wrapper-elm1 project-page-shell">
              <div className="radix-stream-container11 project-page-intro">
                <div className="radix-stream-container12">
                  <div className="radix-stream-container13">
                    <img
                      alt="image"
                      src="/Images/tickerpurple.200.svg"
                      className="radix-stream-image1"
                    />
                    <div className="radix-stream-thq-title-elm">
                      <h1 className="radix-stream-text10 header-project">
                        <span>Radix Stream – Wallet</span>
                        <br></br>
                      </h1>
                    </div>
                    <div className="radix-stream-thq-subtitle-elm">
                      <div className="radix-stream-thq-description-elm1">
                        <h2 className="radix-stream-thq-heading-elm">
                          <span>
                            Radix Stream is a mobile wallet for the Radix DLT
                            network. My work covered product flows, UX/UI, visual
                            identity, and its public website, with a focus on
                            making token storage, transactions, and portfolio
                            monitoring feel clear and dependable on mobile.
                          </span>
                          <br></br>
                        </h2>
                      </div>
                      <div className="radix-stream-thq-tags-elm">
                        <label className="tag-label-big radix-stream-text15">
                          mobile app
                        </label>
                        <label className="radix-stream-text16 tag-label-big">
                          ux/ui
                        </label>
                        <label className="tag-label-big radix-stream-text17">
                          brand
                        </label>
                        <a
                          href="https://radix.stream"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="radix-stream-link"
                        >
                          <label className="radix-stream-text18 tag-label-big">
                            https://radix.stream
                          </label>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="radix-stream-thq-description-elm2">
                  <div className="radix-stream-container14">
                    <span className="radix-stream-text19">context</span>
                    <span className="radix-stream-text20">
                      After the Radix mainnet launch, users needed a reliable
                      mobile alternative to the existing desktop wallets. Many
                      were hesitant to input private keys into third-party apps
                      due to security concerns and found existing solutions
                      overly complex and intimidating. The challenge was to
                      design a mobile experience that built confidence through
                      simplicity, transparency, and ease of use.
                    </span>
                  </div>
                  <div className="radix-stream-container15">
                    <span className="radix-stream-text21">Design</span>
                    <span className="radix-stream-text22">
                      <span>
                        User research and feedback revealed two distinct user
                        groups: passive users who wanted to monitor their
                        accounts and balances without entering seed phrases, and
                        active users who required full wallet functionality for
                        transactions and account management. To accommodate
                        both, I designed a dual onboarding flow that guided each
                        group through a tailored setup, ultimately leading them
                        to a unified dashboard. A persistent toggle allowed
                        seamless switching between Portfolio Tracker and Wallet
                        modes, ensuring clarity and control throughout the
                        experience.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        The interface prioritized readability and
                        predictability, using clean typography instead of token
                        images to reduce visual noise and confusion. This
                        minimalist approach aligned with the early Olympia phase
                        of the Radix network, when smart contracts were not yet
                        available. As the ecosystem matured, additional features
                        such as Domain Names for human-readable addresses and
                        Actions for token-based community engagement, marketing
                        campaigns, and event airdrops were introduced —
                        expanding the wallet’s capabilities while maintaining
                        its focus on clarity and user trust.
                      </span>
                    </span>
                  </div>
                  <div className="radix-stream-container16">
                    <span className="radix-stream-text30">Results</span>
                    <span className="radix-stream-text31">
                      The released product provided a focused mobile entry point
                      to the Radix network. Its dual onboarding, readable
                      portfolio views, and transparent transaction flows were
                      designed to reduce uncertainty while supporting both
                      passive tracking and active wallet use.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="radix-stream-thq-section-elm2">
          <div className="radix-stream-thq-color-wrapper-elm2">
            <div className="radix-stream-container17">
              <div className="radix-stream-thq-pic-elm1">
                <img
                  alt="image"
                  src="/Projects/Web/stream%20w1.png"
                  className="radix-stream-image2"
                />
                <img
                  alt="image"
                  src="/Projects/Web/stream%20w2.png"
                  className="radix-stream-image3"
                />
                <img
                  alt="image"
                  src="/Projects/Web/stream%20w3.png"
                  className="radix-stream-image4"
                />
                <div className="radix-stream-container18">
                  <img
                    alt="image"
                    src="/Projects/stream%20wallet%20screens.jpg"
                    className="radix-stream-image5"
                  />
                  <div className="radix-stream-thq-description-elm3">
                    <p className="radix-stream-text32">
                      The mobile application included over 60 distinct screens
                      and overlays, carefully designed to ensure a seamless,
                      intuitive, and consistent user experience throughout every
                      interaction.
                    </p>
                  </div>
                </div>
                <div className="radix-stream-container19">
                  <img
                    alt="image"
                    src="/Projects/Web/stream%20w4.png"
                    className="radix-stream-image6"
                  />
                </div>
              </div>
              <div className="radix-stream-thq-pic-elm2">
                <div className="radix-stream-thq-description-elm4">
                  <p className="radix-stream-text33">
                    The homepage followed a minimalistic design and clear
                    guidance for where to download the app and what its main
                    features were. 
                  </p>
                </div>
                <img
                  alt="image"
                  src="/Projects/radix%20stream%20website.png"
                  className="radix-stream-image7"
                />
                <img
                  alt="image"
                  src="/Projects/radix%20stream%20pro.png"
                  className="radix-stream-image8"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer rootClassName="footerroot-class-name2"></Footer>
      </div>
    </div>
  )
}

export default RadixStream
